export default "__VITE_ASSET__DJlA3sFL__"